import type { SlideElement } from '@livequiz/shared';

/**
 * Rendert die frei platzierten Overlay-Elemente einer Folie (Text/Bild/GIF).
 * Als absolute Ebene über der Folie; Positionen/Größen in Prozent, Schriftgröße
 * in `cqw` – identisch zur Editor-Vorschau, daher pixelgleiche Anordnung.
 * Der Eltern-Container muss `container-type: size` und `position: relative` haben.
 */
export function SlideElements({ elements }: { elements?: SlideElement[] }) {
  if (!elements?.length) return null;
  return (
    <div className="absolute inset-0 pointer-events-none">
      {elements.map((el) => (
        <div
          key={el.id}
          className="absolute"
          style={{
            left: `${el.x}%`,
            top: `${el.y}%`,
            width: `${el.w}%`,
            transform: el.rotation ? `rotate(${el.rotation}deg)` : undefined,
          }}
        >
          {el.kind === 'image' && el.src ? (
            <img src={el.src} alt="" style={{ width: '100%', display: 'block' }} />
          ) : (
            <div style={{ color: el.color ?? '#fff', fontSize: `${el.fontSize ?? 6}cqw`, fontFamily: el.fontDisplay || 'inherit', fontWeight: el.bold ? 800 : 600, lineHeight: 1.1, whiteSpace: 'pre-wrap' }}>
              {el.text}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
